import { h, Component } from 'preact';
import style from './style.less'
import {classNames} from '../../../lib/helpers'

export default (props)=>{
    let classes = [
        style.textCenter,
        props.class,
        style.largeLoading
    ]
    
    return (
        <div class={classNames(...classes)}>
            <i class={`fa fa-spinner fa-spin`} aria-hidden="true"></i>
            &nbsp; Loading {props.children || props.loadingType}
        </div>
        
    )
}


// WEBPACK FOOTER //
// ./components/elements/Loading/index.js